import PropTypes from 'prop-types';
import { ManCard, ManText } from '@craft-design-system/core-components-react';
import PopoverComponent from '../popover';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
// import { ManRadioButtonGroup, ManRadioButton,ManText,ManCard } from '@craft-design-system/core-components-react';
import ifav from './ifav.png';
import { Card } from 'react-bootstrap';
import Zoom from '../Zoom';

const Start_of_data_acquisition = ({ value }) => {
  const [start_of_data_acquisition, set_start_of_data_acquisition] = useState(null);

  console.log('packs',value)

 





  useEffect(() => {
    try {
        set_start_of_data_acquisition(JSON.parse(value));
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
    <Card className='card_ride' appearance="soft" outline="false">
      <div className="card-title" style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px', // Consistent spacing
  marginBottom: '8px' // Match previous layouts
}}>
  <div style={{
    flex: 1,
    display: 'flex',
    justifyContent: 'center', // Center text horizontally
    alignItems: 'center' // Center text vertically
  }}>
    <ManText   
      className="card-title-text"
      variant="component-l"
      as="span"
      size="l"
      style={{ lineHeight: 'normal' }} // Prevent typography shifts
    >
      Start of data acquisition
    </ManText>
  </div>
  <div style={{
flexShrink: 0,
display: 'flex',
alignItems: 'center', // Ensure icon aligns with text
height: '100%', // Match height to parent for consistent alignment
flexDirection:"row-reverse"
  }}>
    <PopoverComponent
      id="median_consumption"
      content="<b>Start of Data Acquisition:</b> This KPI shows the earliest time stamp at which telematics data is available for the selected vehicle. This time stamp is the baseline for different KPIs on the dashboard (e.g. total mileage).<br/><br/><b>Time Series Data:</b><br/>If multiple vehicles are selected, the cumulative count of vehicles over time is displayed. You can see at which point in time which number of vehicles was providing data."
      style={{ verticalAlign: 'middle' }} // Ensure icon alignment
    />
        <Zoom
    chartData={start_of_data_acquisition?.data}
    chartLayout={start_of_data_acquisition?.layout}
    chartTitle="Start of data acquisition"
  />
  </div>
</div>
      


      <div >
      {start_of_data_acquisition && start_of_data_acquisition.data ? (
  <div style={{ width: '100%', height: '420px' }}>
    <Plot
      data={start_of_data_acquisition.data}
      layout={{
        ...start_of_data_acquisition.layout,
        // autosize: true, // Ensures the plot scales to fit the container
        // margin: { t: 10, r: 10, l: 10, b: 10 }, // Keep your margin settings
      }}
      style={{ width: '100%', height: '100%' }} // Set Plot to fill the container
      useResizeHandler={true} // Enables responsiveness to container size changes
    />
  </div>
) : (
  <div>
    <ManText className="card-title-text" variant="component-l" as="span" size="l">
      {value}
    </ManText>
  </div>
)}
    </div>
      </Card>
  );
};

Start_of_data_acquisition.propTypes = {
  value: PropTypes.number.isRequired,
};

export default Start_of_data_acquisition;